import { useCallback } from 'react';
import { useParams } from 'react-router';
import { ShiftGeneratorTaskService } from 'src/api/ShiftGeneratorTaskService';
import type { ShiftGeneratorTask } from 'src/api/ShiftGeneratorTaskService';
import { invalidateShiftGeneratorTaskData } from '@stores/shiftGeneratorTaskStore';

type CreateTask = (
    task: ShiftGeneratorTask,
) => Promise<ShiftGeneratorTask | undefined>;

const useCreateTask = (): { createTask: CreateTask } => {
    const { departmentId } = useParams<{
        departmentId: string;
    }>();

    const createTask = useCallback<CreateTask>(
        async (task) => {
            if (!departmentId) {
                throw new Error(
                    'useCreateTask requires a departmentId route param',
                );
            }

            const createdTask = await ShiftGeneratorTaskService.createTask(
                departmentId,
                task,
            );

            if (!createdTask) {
                return undefined;
            }

            invalidateShiftGeneratorTaskData();

            return createdTask;
        },
        [departmentId],
    );

    return { createTask };
};

export default useCreateTask;
